import { Component, OnInit, Renderer2 } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IConfig } from 'src/app/core/interfaces/config.interface';
import { IInduction } from 'src/app/core/interfaces/induction.interface';
import { Theme } from 'src/app/core/interfaces/theme.interface';
import { DataService } from 'src/app/services/data.service';
import { FormService } from 'src/app/services/form.service';
import { ThemeService } from 'src/app/services/theme.service';

@Component({
  selector: 'app-induction-profile',
  templateUrl: './induction-profile.component.html',
  styleUrls: ['./induction-profile.component.scss'],
})
export class InductionProfileComponent implements OnInit {
  inductionProfile: IInduction | undefined;
  id: string = '';
  client: string = '';
  isValidPass: boolean = false;
  config: IConfig;

  // Properties for acknowledgement functionality
  showAcknowledgeButton: boolean = false;
  acknowledgeToken: string = '';
  isAcknowledging: boolean = false;
  acknowledgementComplete: boolean = false;
  acknowledgementError: string = '';

  constructor(
    private dataSvc: DataService,
    private formSvc: FormService,
    private route: ActivatedRoute,
    private router: Router,
    private themeSvc: ThemeService,
    private renderer2: Renderer2
  ) {
    this.route.queryParams.subscribe((params) => {
      this.id = params['id'];
      this.client = params['client'];
      debugger;
      // Check for acknowledge parameter
      this.acknowledgeToken = params['acknowledge'];
      this.showAcknowledgeButton = !!this.acknowledgeToken;

      if (this.id) {
        this.dataSvc.getConfig(this.client).subscribe((y) => {
          //this.themeSvc.setTheme(y?.heading, this.renderer2);
          this.dataSvc.getInduction(this.id, this.client).subscribe((x) => {
            if (x) {
              this.inductionProfile = x;

              var expiryDate = new Date(this.inductionProfile.expiryDate);

              if (new Date() <= expiryDate) {
                this.isValidPass = true;
              }
            }
          });
        });
      }
    });
  }

  ngOnInit(): void {}

  // Method to handle acknowledgement using FormService
  acknowledgeInduction(): void {
    if (!this.acknowledgeToken || !this.id || !this.client) {
      this.acknowledgementError = 'Invalid acknowledgement request.';
      return;
    }

    this.isAcknowledging = true;
    this.acknowledgementError = '';

    // Use FormService instead of DataService
    this.formSvc.acknowledgeInduction(this.client, this.id).subscribe({
      next: (response) => {
        if (response && response.success) {
          this.acknowledgementComplete = true;
          this.showAcknowledgeButton = false;
          this.isAcknowledging = false;
        } else {
          this.acknowledgementError =
            response?.message || 'Failed to acknowledge induction.';
          this.isAcknowledging = false;
        }
      },
      error: (error) => {
        console.error('Acknowledgement error:', error);
        this.isAcknowledging = false;
      },
    });
  }
}
